<template>
  <div class="modal fade delete-payment-method-modal" id="DeletePaymentMethodModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Deletar método de pagamento</h1>
                  <button type="button" class="btn-close delete-payment-method-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formDeletePaymentMethod" @submit.prevent="deletePaymentMethodFunction">
                <div class="modal-body ps-30 pe-30">
                  <p class="fw-bold">Tem certeza que deseja deletar este método de pagamento?</p>
                  <p v-if="getCurrentDeletePaymentMethod" class="text-danger fw-bold">
                    Método: {{ getCurrentDeletePaymentMethod.name }}
                  </p>
                  <p class="text-muted">Esta ação não pode ser desfeita.</p>

                  <div class="col-12">
                    <div id="alertResponseApiDeletePaymentMethod" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageDeletePaymentMethod"></div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary delete-payment-method-modal" data-bs-dismiss="modal">Cancelar</button>
                  <button type="submit" ref="buttonDeletePaymentMethod" class="btn btn-danger">Deletar método</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../config/axios.js';
import { mapGetters } from 'vuex';

export default {
  name: "DeletePaymentMethodModal",
  computed: {
    ...mapGetters([
      "getCurrentDeletePaymentMethod"
    ]),
  },
  methods: {
    deletePaymentMethodFunction() {
      const alertResponse = this.alertResponse;
      const paymentMethodId = this.getCurrentDeletePaymentMethod.id;

      if (!paymentMethodId) {
        this.alertResponse("Erro ao deletar método de pagamento", true);
        return;
      }

      const objPaymentMethodDelete = {
        "id": paymentMethodId
      }

      const buttonDeletePaymentMethod = this.$refs.buttonDeletePaymentMethod;
      buttonDeletePaymentMethod.disabled = true;
      buttonDeletePaymentMethod.innerHTML = "Deletando método...";
      
      api.axios.post("/api/payment-methods/delete", objPaymentMethodDelete).catch(function(error) {
        buttonDeletePaymentMethod.disabled = false;
        buttonDeletePaymentMethod.innerHTML = "Deletar método";
        console.log("error", error);
        if (error.response && error.response.data) {
          alertResponse(error.response.data.message || "Erro ao deletar método de pagamento", true);
        } else {
          alertResponse("Erro ao deletar método de pagamento", true);
        }
      }).then(function(response) {
        if (response !== undefined && response.status == 200) {
          buttonDeletePaymentMethod.innerHTML = "Método deletado com sucesso!";
          window.location.reload();
        } else {
          buttonDeletePaymentMethod.disabled = false;
          buttonDeletePaymentMethod.innerHTML = "Deletar método";
        }
      });
    },
    alertResponse(message, error) {
      const warningMessage = `<i class="flaticon flaticon-warning"></i> ` + message;
      const successMessage = `<i class="flaticon flaticon-check"></i> ` + message;
      
      if (error) {
        document.getElementById("errorMessageDeletePaymentMethod").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageDeletePaymentMethod").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiDeletePaymentMethod");
      if (elementAlert) {
        if (error) {
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }
    },
  }
};
</script>
